<template>
    <div class="site-panel v-flex" style="border-bottom-style: solid; border-bottom-width: 1px; border-radius: 0" v-if="site">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab no-border ma-0 mr-1">
                <v-row class="no-frame">
                    <c-assessment-card-iterator
                        :assessments = "assessments"
                        @selected    = "onSelected"
                        class        = "w-100 maintenance-column pb-1"
                    />
                </v-row>
            </v-col>
            <v-col class="main-middlle-last-col modal-tab no-border ma-0 mr-1 pr-3">
                <v-row class="no-frame" v-if="selected">
                    <c-column-header label="Meldung" class="primary w-100 mt-2" />
                    <div v-if="selected.documents && selected.documents[0]">

                    </div>
                    <c-dms-viewer
                        v-if="selected.documents && selected.documents[0]"
                        style="height: calc(100% - 44px); margin-top: 0;"
                        :document = "selected.documents[0].id"
                    />
                </v-row>
            </v-col>
            <v-col class="main-last-col modal-tab no-border ma-0 pl-0">
                <v-row class="no-frame"  v-if="selected">
                    <c-column-header
                        label="Mängelliste"
                        class="primary w-100 mt-2"
                    />
                    <div class=" mt-1 mb-3 w-100 maintenance-column">
                        <div v-if="selected" class="lm-border pa-3 w-100 " style="height: 797px;">
                            <div
                                v-for="(fault, index) in selected.faults"
                                :key="index"
                            >
                                <div class="v-flex mb-4">
                                    <div
                                        class  = "fault-rating"
                                        :class = "color(fault)"
                                    >
                                        {{ ratingName(fault.rating) }}
                                    </div>

                                    <v-textarea
                                        v-model        = "fault.description"
                                        rows           = "6"
                                        class          = "mt-0 pt-0 pr-1"
                                        ref            = "description"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        no-resize
                                        hide-details
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Dms                     from "@/modules/dms/common/service/Dms";
import Assessment              from "@/modules/inc/assessments/service/Assessment";
import CColumnHeader           from "@/modules/core/components/utils/CColumnHeader";
import CAssessmentCardIterator from "@/modules/inc/assessments/components/CAssessmentCardIterator";
import CDmsViewer from "@/modules/dms/viewer/CDmsViewer.vue";

export default {
    name: "TSiteAssessment",

    components: {
        CDmsViewer,
        CAssessmentCardIterator,
        CColumnHeader,
    },

    props: {
        site: {

        }
    },

    data: () => ({
        assessments: null,
        selected   : null,
        documentUrl: null,
        refresh    : 0
    }),

    computed: {
        siteId () {
            if (!this.site) {
                return null;
            }

            return this.site.id;
        },
    },

    watch: {
        siteId () {
            this.initialize();
        }
    },

    mounted() {
        this.initialize();
    },

    methods: {
        initialize () {
            if (!this.siteId) {
                return;
            }

            Assessment.list(this.siteId, (data) => {
                this.assessments = data;
            })
        },

        onSelected (assessment) {
            this.selected = assessment;
            if (!this.selected || !this.selected.documents || this.selected.documents.length === 0) {
                this.documentUrl = null;
            } else {
                const documentId = this.selected.documents[0].id;
                this.documentUrl = Dms.document(documentId);
            }

            this.refresh ++;
        },

        color (fault) {
            return Assessment.ratings[fault.rating.id].color;
        },

        ratingName (rating) {
            return Assessment.ratingName (rating);
        },
    }
}

</script>

<style scoped>

.maintenance-column {
    height: calc(100% - 50px);
}

.fault-rating {
    width: 25px;
    color: white;
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    text-orientation: sideways;
    font-size: 15px;
    text-align: center;
    padding-left: 3px;
    padding-top: 5px;
    margin-right: 3px;
    padding-bottom: 10px;
    border-radius: 4px;
    cursor: move;
}

</style>